import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get Contracts
export const getContracts = createAsyncThunk(
  "contract/getContracts",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (params.project_id)
        queryParams.append("project_id", params.project_id);
      if (params.customer_id)
        queryParams.append("customer_id", params.customer_id);
      if (params.status) queryParams.append("status", params.status);
      if (
        params.is_active !== undefined &&
        params.is_active !== null &&
        params.is_active !== ""
      ) {
        queryParams.append("is_active", params.is_active);
      }

      const url = `${BASE_URL}/contracts${
        queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get contracts!";
      return rejectWithValue(message);
    }
  },
);

// Get contract Details
export const getContractsDetails = createAsyncThunk(
  "contracts/getContractDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.get(`${BASE_URL}/contracts/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get contract details!";
      return rejectWithValue(message);
    }
  },
);

// Delete Contract
export const deleteContracts = createAsyncThunk(
  "contract/deleteContracts",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.delete(`${BASE_URL}/contracts/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to delete contract!";
      return rejectWithValue(message);
    }
  },
);

// Add Contract
export const addContract = createAsyncThunk(
  "contracts/addContract",
  async (contractsData, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      let url;
      if (contractsData.quotation_id) {
        url = `${BASE_URL}/contracts/from-quotation/${contractsData.quotation_id}`;
      } else {
        url = `${BASE_URL}/contracts`;
      }

      const { quotation_id, ...dataToSend } = contractsData;

      const response = await axios.post(url, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        return rejectWithValue(errorMessages.join(", "));
      }
      const message =
        error.response?.data?.message || "Failed to add Contract!";
      return rejectWithValue(message);
    }
  },
);

// update Contract
export const updateContract = createAsyncThunk(
  "contract/updateContract",
  async ({ id, contractsData }, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        throw new Error("No authentication token found");
      }
      const currentLang = getCurrentLanguage();
      const response = await axios.put(
        `${BASE_URL}/contracts/${id}`,
        contractsData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        return rejectWithValue(errorMessages.join(", "));
      }
      const message =
        error.response?.data?.message || "Failed to update contract!";
      return rejectWithValue(message);
    }
  },
);
